import { Component } from '@angular/core';
import { Platform } from '@ionic/angular';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { UserService } from './services/user.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {
  constructor(
    private platform: Platform,
    private _db: AngularFirestore,
    private _afAuth: AngularFireAuth,
    private _userService: UserService,
    private _router: Router
  ) {
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
     this._afAuth.authState.subscribe( user => {
       
       if(user)  this._db.collection('usuarios').doc(user.uid).valueChanges()
       .subscribe( (user: any) => {
         if(user.active) this._userService.setUser(user)
         else {
           this._router.navigateByUrl('/login')
           this._afAuth.signOut()
         }
       })
     })
    });
  }
}
